import {Box, BoxProps} from '@chakra-ui/react'
import {SingleChildrenProps} from 'models/interfaces'

const BoxCard = (props: BoxProps & SingleChildrenProps) => (
  <Box w='full' borderRadius='2xl' p={5} border='solid 1px' borderColor='gray.200' {...props} />
)

export default BoxCard
